import { useState } from "react";
import { FaUser } from "react-icons/fa6";
import { GoHome } from "react-icons/go";
import { HiClipboardDocumentCheck } from "react-icons/hi2";
import { IoDocument } from "react-icons/io5";
import { MdOutlineGridView, MdOutlineShareLocation } from "react-icons/md";
import lossLoti from "../Utils/Lottie/loss.json";
import SuccessLoti from "../Utils/Lottie/success.json";
import winLoti from "../Utils/Lottie/win.json";

export const fileBaseUrl = process.env.REACT_APP_API_FILES_URL;

export const getSource = (source) => {
  switch (source) {
    case "Technical Feasibility":
      return "technical_feasibility";
    case "Financial Feasibility":
      return "financial_feasibility";
    case "Tax Certificate":
      return "tax_certificate";
    case "Other":
      return "other";
    case "All":
      return "all";
    default:
      return "";
  }
};

export const getAttachmentName = (source) => {
  switch (source) {
    case "technical_feasibility":
      return "Technical Feasibility";
    case "financial_feasibility":
      return "Financial Feasibility";
    case "tax_certificate":
      return "Tax Certificate";
    case "other":
      return "Other";
    case "all":
      return "All";
    default:
      return "";
  }
};

export const getUserDetail = () => {
  return JSON.parse(localStorage.getItem("tmsUserDetail"));
};

export const generateRandomColors = (count) => {
  const colors = [
    "rgba(255, 182, 193, 0.99)", // Light pink
    "rgb(173, 216, 230)", // Light blue
    "rgb(144, 238, 144)", // Light green
    "rgb(255, 218, 185)", // Peach
    "rgb(221, 160, 221)", // Plum
    "rgb(176, 196, 222)", // Light steel blue
    "rgb(255, 255, 178)", // Light yellow
    "rgb(200, 162, 200)", // Lavender
    "rgb(152, 251, 152)", // Pale green
    "rgb(255, 160, 122)", // Light salmon
  ];
  return colors.slice(0, count);
};

export const pieOptions = {
  plugins: {
    legend: {
      position: "right",
      labels: {
        font: {
          size: 12,
        },
      },
    },
    title: {
      display: true,
      text: "Departmental Tenders Distribution",
      font: {
        size: 16,
      },
    },
    tooltip: {
      callbacks: {
        label: function (context) {
          const label = context.label || "";
          const value = context.raw || 0;
          return `${label}: ${value}`;
        },
      },
    },
    datalabels: {
      color: "#000",
      font: {
        weight: "bold",
        size: 14,
      },
      formatter: (value) => {
        return value;
      },
    },
  },
  maintainAspectRatio: false,
};

export const validateData = (data) => {
  for (const key in data) {
    if (data[key] === null || data[key] === undefined || data[key] === "") {
      throw new Error(`Please filled up all fields`);
    }
    if (typeof data[key] === "object") {
      validateData(data[key]);
    }
  }
};

export const tenderDate = (closingDate) => {
  let currentDate = new Date();
  let dueDate = new Date(closingDate);
  let differenceInDays = Math.floor(
    (dueDate - currentDate) / (1000 * 60 * 60 * 24)
  );

  if (dueDate < currentDate) {
    return "Expired";
  } else if (differenceInDays <= 10) {
    return "Closing";
  }
  return "Active";
};

export const statusCheck = (closingDate) => {
  let currentDate = new Date();
  let dueDate = new Date(closingDate);
  let differenceInDays = Math.floor(
    (dueDate - currentDate) / (1000 * 60 * 60 * 24)
  );

  if (dueDate < currentDate) {
    return "Expired";
  } else if (differenceInDays <= 10) {
    return "Closing";
  }
  return "Active";
};

export const formatDate = (dateString) => {
  if (!dateString) return "";
  return dateString.split(" ")[0];
};

export const dashboardColorStyles = {
  control: (baseStyles, state) => ({
    ...baseStyles,
    backgroundColor: "white",
    borderRadius: "5px",
    cursor: "pointer",
    fontSize: "13px",
    boxShadow: "none",
    borderColor:
      state.isFocused || state.isHovered || state.isActive || state.onHovered
        ? "#003a70"
        : "#787878",
    minWidth: "300px",
    color:
      state.selectProps.value?.value === "interested"
        ? "green"
        : state.selectProps.value?.value === "not-interested"
        ? "red"
        : "#000",
    "&:hover": {
      borderColor: state.isFocused || state.isActive ? "#003a70" : "#787878",
    },
  }),
  option: (provided, state) => ({
    ...provided,
    cursor: "pointer",
    color:
      state.data.value === "interested"
        ? "green"
        : state.data.value === "not-interested"
        ? "red"
        : "#000",
    backgroundColor: state.isSelected ? "#F5F9FC" : "#fff",
    fontSize: "14px",
  }),
};

export const statusStyles = {
  control: (baseStyles, state) => ({
    ...baseStyles,
    backgroundColor: "white",
    borderRadius: "5px",
    cursor: "pointer",
    fontSize: "12px",
    boxShadow: "none",
    minHeight: "32px",
    minWidth: "130px",
    borderColor:
      state.isFocused || state.isHovered || state.isActive || state.onHovered
        ? "#003a70"
        : "#78787840",
    color:
      state.selectProps.value?.value === "interested"
        ? "green"
        : state.selectProps.value?.value === "not-interested"
        ? "red"
        : "#000",
    "&:hover": {
      borderColor: state.isFocused || state.isActive ? "#003a70" : "#78787840",
    },
  }),
  valueContainer: (baseStyles, state) => ({
    ...baseStyles,
    padding: "0 5px",
  }),
  indicatorContainer: (baseStyles, state) => ({
    ...baseStyles,
    padding: "5px",
  }),
  option: (provided, state) => ({
    ...provided,
    cursor: "pointer",
    color:
      state.data.value === "interested"
        ? "green"
        : state.data.value === "not-interested"
        ? "red"
        : "#000",
    backgroundColor: state.isSelected ? "#F5F9FC" : "#fff",
    fontSize: "14px",
  }),
};

export const userDepartmentStyles = {
  control: (baseStyles, state) => ({
    ...baseStyles,
    backgroundColor: "white",
    borderRadius: "5px",
    cursor: "pointer",
    fontSize: "13px",
    boxShadow: "none",
    borderColor: "none",
    border: "none",
    borderStyle: "none",
    color:
      state.selectProps.value?.value === "interested"
        ? "green"
        : state.selectProps.value?.value === "not-interested"
        ? "red"
        : "#000",
    "&:hover": {
      borderColor: state.isFocused || state.isActive ? "#003a70" : "#787878",
    },
  }),
  option: (provided, state) => ({
    ...provided,
    cursor: "pointer",
    color:
      state.data.value === "interested"
        ? "green"
        : state.data.value === "not-interested"
        ? "red"
        : "#000",
    backgroundColor: state.isSelected ? "#F5F9FC" : "#fff",
    fontSize: "14px",
  }),
};

export const departmentStyles = {
  control: (baseStyles, state) => ({
    ...baseStyles,
    backgroundColor: "white",
    borderRadius: "5px",
    cursor: "pointer",
    fontSize: "13px",
    boxShadow: "none",
    borderColor:
      state.isFocused || state.isHovered || state.isActive || state.onHovered
        ? "#003a70"
        : "#787878",
    color:
      state.selectProps.value?.value === "interested"
        ? "green"
        : state.selectProps.value?.value === "not-interested"
        ? "red"
        : "#000",
    "&:hover": {
      borderColor: state.isFocused || state.isActive ? "#003a70" : "#787878",
    },
  }),
  option: (provided, state) => ({
    ...provided,
    cursor: "pointer",
    color:
      state.data.value === "interested"
        ? "green"
        : state.data.value === "not-interested"
        ? "red"
        : "#000",
    backgroundColor: state.isSelected ? "#F5F9FC" : "#fff",
    fontSize: "14px",
  }),
};

export const TableStyles = {
  control: (baseStyles, state) => ({
    ...baseStyles,
    fontSiza: "11px",
    color:
      state.selectProps.inputValue === "yes"
        ? "green"
        : state.selectProps.inputValue === "no"
        ? "red"
        : "black",
    backgroundColor: "white",
    borderRadius: "5px",
    cursor: "pointer",
    boxShadow: "none",
    borderColor:
      state.isFocused || state.isHovered || state.isActive || state.onHovered
        ? "#003a70"
        : "#787878",
    "&:hover": {
      borderColor: state.isFocused || state.isActive ? "#003a70" : "#787878",
    },
    minWidth: "150px",
    position: "relative",
  }),
  option: (provided, state) => ({
    ...provided,
    cursor: "pointer",
    color:
      state.data.value === "yes"
        ? "green"
        : state.data.value === "no"
        ? "red"
        : "#000",
    backgroundColor: state.isSelected ? "#F5F9FC" : "#fff",
    fontWeight: "600",
  }),
};

export const dashboardSidebar = [
  {
    path: "/dashboard",
    icon: <GoHome />,
    title: "Dashboard",
  },
  {
    path: "/dashboard/all-tenders",
    icon: <MdOutlineGridView />,
    title: "All Tenders",
  },
  {
    path: "/dashboard/assigned-tenders",
    icon: <HiClipboardDocumentCheck />,
    title: "Assigned Tenders",
  },
  {
    path: "/dashboard/interested-tenders",
    icon: <IoDocument />,
    title: "Interested Tenders",
  },
  {
    path: "/dashboard/applied-tenders",
    icon: <MdOutlineShareLocation />,
    title: "Applied Tenders",
  },
  {
    path: "/dashboard/profile",
    icon: <FaUser />,
    title: "Profile",
  },
];

export const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: SuccessLoti,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

export const LossOptions = {
  loop: true,
  autoplay: true,
  animationData: lossLoti,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

export const winOptions = {
  loop: false,
  autoplay: true,
  animationData: winLoti,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

export const logoutHandler = () => {
  localStorage.removeItem("tmsToken");
  localStorage.removeItem("tmsUserDetail");
  window.location.href = "/";
};

export const handleDownload = (url) => {
  return url.replace("https://", "http://");
};

export const getDropdownPosition = (index, totalLength) => {
  if (totalLength <= 2) return "top";

  if (totalLength % 2 === 0) {
    return index >= totalLength - 2 ? "top" : "bottom";
  } else {
    return index === totalLength - 1 ? "top" : "bottom";
  }
};

export const TruncateText = (text, wordCount = 7) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const words = text.split(" ");

  if (words.length <= wordCount) {
    return <span style={{ color: "#373737" }}>{text}</span>;
  }

  return (
    <span style={{ color: "#373737", fontWeight: "500", fontSize: "14px" }}>
      {isExpanded ? text : `${words.slice(0, wordCount).join(" ")}`}
      <span style={{ color: "#666" }}>
        {!isExpanded && "..."}
        <span
          onClick={() => setIsExpanded(!isExpanded)}
          style={{
            color: "#003A70",
            cursor: "pointer",
            fontWeight: "600",
            marginLeft: "4px",
          }}
        >
          {isExpanded ? "Show less" : "Show more"}
        </span>
      </span>
    </span>
  );
};

export const formatTimestamp = (timestamp) => {
  if (!timestamp) return "";

  const date = new Date(timestamp);
  const now = new Date();
  const diffInSeconds = Math.floor((now - date) / 1000);
  const diffInMinutes = Math.floor(diffInSeconds / 60);
  const diffInHours = Math.floor(diffInMinutes / 60);
  const diffInDays = Math.floor(diffInHours / 24);

  if (diffInSeconds < 60) {
    return "just now";
  } else if (diffInMinutes < 60) {
    return `${diffInMinutes} ${diffInMinutes === 1 ? "min" : "mins"} ago`;
  } else if (diffInHours < 24) {
    return `${diffInHours} ${diffInHours === 1 ? "hour" : "hours"} ago`;
  } else if (diffInDays < 7) {
    return `${diffInDays} ${diffInDays === 1 ? "day" : "days"} ago`;
  } else {
    return date.toLocaleDateString();
  }
};
